import app from 'flarum/common/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import ItemList from 'flarum/common/utils/ItemList';
import listItems from 'flarum/common/helpers/listItems';
import LinkButton from 'flarum/common/components/LinkButton';
import Button from 'flarum/common/components/Button';
import classList from 'flarum/common/utils/classList';
import IndexPage from 'flarum/forum/components/IndexPage';
import AlertUtil from 'flarum/forum/dianLiang/AlertUtil';
import fullTime from 'flarum/common/helpers/fullTime';
/**
 *发帖提示按钮
 * ### Props
 *
 * - `page`
 */
export default class FloatPromptButton extends Component {
  oninit(vnode) {
    super.oninit(vnode);

    // 文本数组
    this.texts = JSON.parse(app.data.pkgLogo.postButtonPrompt)[app.data.locale];

    // 当前显示的文本索引
    this.currentTextIndex = 0;

    // 是否显示文本
    this.showText = false;

    // 是否被"静音"
    this.isMuted = true;

    // 5秒自动关闭的定时器
    this.autoCloseTimer = null;
  }

  oncreate(vnode) {
    super.oncreate(vnode);

    // 每次打开页面都自动播放30秒后关闭
    this.startTalking();
  }

  onremove(vnode) {
    super.onremove(vnode);

    // 组件被卸载时清理定时器
    if (this.autoCloseTimer) {
      clearTimeout(this.autoCloseTimer);
      this.autoCloseTimer = null;
    }
  }

  /**
   * 显示文本并每 3 秒轮播一次文案，30秒后自动关闭
   */
  startTalking() {
    this.isMuted = false;
    this.showText = true;

    // 立即随机选一个起始文案
    if (this.texts && this.texts.length) {
      this.currentTextIndex = Math.floor(Math.random() * this.texts.length);
    }

    if (!this.texts || !this.texts.length) return;

    // 随机选一个新索引，尽量避免和当前索引相同
    let newIndex = this.currentTextIndex;
    if (this.texts.length > 1) {
      while (newIndex === this.currentTextIndex) {
        newIndex = Math.floor(Math.random() * this.texts.length);
      }
    }
    this.currentTextIndex = newIndex;
    m.redraw();

    // 5秒后自动关闭
    this.autoCloseTimer = setTimeout(() => {
      this.stopTalking();
    }, 5000);
  }

  /**
   * 隐藏文本并停止轮播
   */
  stopTalking() {
    this.isMuted = true;
    this.showText = false;

    if (this.autoCloseTimer) {
      clearTimeout(this.autoCloseTimer);
      this.autoCloseTimer = null;
    }

    m.redraw();
  }

  toggleText(event) {
    // 阻止事件冒泡
    if (event) {
      event.stopPropagation();
    }

    if (this.isMuted) {
      // 重新开始说话，5秒后自动关闭
      this.startTalking();
    } else {
      // 播放时用户点击则提前关闭
      this.stopTalking();
    }
  }

  view() {
    return (
      <div className="floatingPromptWrapper">
        {/* 文本显示区域 */}
        {this.showText && (
          <div className="floatingPromptText">
            <div className="promptTextContent">{m.trust(this.texts[this.currentTextIndex])}</div>
          </div>
        )}

        {/* 浮动按钮 */}
        <Button
          className="floatingPromptContainer"
          onclick={(event) => {
            this.toggleText(event);
          }}
        >
          {this.showText && (
            <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/com-jh02.png`} alt="Floating Image" className="floatingPromptLight" />
          )}
          <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/com-jh01.png`} alt="Floating Image" className="floatingPrompt" />
        </Button>
      </div>
    );
  }
}
